import offerCreditImage from "../../Assets/Images/su-offer-credit.png";
import offerInternetImage from "../../Assets/Images/su-offer-internet.png";
import offerMoveInImage from "../../Assets/Images/su-offer-move-in.png";
import offerNeighborhoodImage from "../../Assets/Images/su-offer-neighborhood.png";
import offerPowerImage from "../../Assets/Images/su-offer-power.png";
import offerRentImage from "../../Assets/Images/su-offer-rent.png";
import PrimaryButton from "./primary-button";
import { UTILITIES_STEPS_ENABLED, formatMoney } from "./utilities-config";

// Paper "You decide": what the member gets with a Stake account, then open it or come back later.
export default function Decide({ amount, offer, onOpen, onLater }) {
  const rows = [
    { image: offerMoveInImage, title: "Move-in Cash", value: amount || "Yours", done: true },
    ...(UTILITIES_STEPS_ENABLED
      ? [
          { image: offerPowerImage, title: "Stake Power", prefix: "Up to", value: formatMoney(offer.powerCashBack) },
          { image: offerInternetImage, title: "Stake TV & Internet", prefix: "Up to", value: formatMoney(offer.homeServicesCashBack) },
        ]
      : []),
    { image: offerRentImage, title: "Cash Back on Rent", prefix: "Up to", value: formatMoney(offer.rentCashBackPerMonth), suffix: "/mo" },
    { image: offerCreditImage, title: "Credit Builder", value: "Free" },
    { image: offerNeighborhoodImage, title: "Neighborhood Cash", value: "Unlimited" },
  ];
  return (
    <section className="su-decide">
      <div className="su-decide-copy">
        <h1 className="su-display">
          RENTING FINALLY
          <br />
          PAYS YOU BACK.
        </h1>
        <p className="su-decide-sub">
          {amount ? `Your ${amount} lands here.` : "Your Move-in Cash lands here."} So does all your Cash Back.
          <br />
          FDIC insured through Midland States Bank.
        </p>
        <div className="su-decide-actions">
          <PrimaryButton onClick={onOpen}>Open my Stake Account</PrimaryButton>
          <PrimaryButton variant="ghost" onClick={onLater}>
            Later
          </PrimaryButton>
        </div>
        <p className="su-decide-legal">Stake is not a bank. Banking services provided by Midland States Bank, SSB, Member FDIC.</p>
      </div>
      <div className="su-decide-panel">
        {rows.map((row) => (
          <div className="su-decide-row" key={row.title}>
            <img src={row.image} alt="" />
            <span className="su-decide-title">{row.title}</span>
            <span className="su-decide-value">
              {row.prefix ? <small>{row.prefix}</small> : null}
              <b>{row.value}</b>
              {row.suffix ? <small>{row.suffix}</small> : null}
              {row.done ? (
                <i aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 12 12">
                    <path d="M2.5 6.2L5 8.5L9.5 3.5" fill="none" stroke="#0E1118" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </i>
              ) : null}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
